import { AttributeGroup } from 'state/attributeGroup'
import { classList } from 'MK/DOM/fns/classList'
// import { Product } from 'state/product'
import { config } from 'state/attributeGroup/config'

// const syncWithDOM = (group) => {
//   if (!group.isActive()) return

//   let parentNode = AttributeGroup.container || document.getElementById(config.selectors.id.groups)

//   group.selected.attributes.length > 0 ? group.nodes.title.setAttribute('data-count', `${group.selected.attributes.length}`) : group.nodes.title.removeAttribute('data-count')
//   // Sync each attribute of the current group
//   group.attributes.filter(attribute => attribute.is.active).forEach(attribute => {
// if (attribute.activeCounts) {
//   attribute.count = Product.display.by.id ? attribute.activeCounts.productIDs : attribute.activeCounts.aliases
//   attribute.is.active = attribute.count > 0 || attribute.is.selected
//   // console.log(`${attribute.name}, Count:`, attribute.count, attribute.activeCounts)
// }
//   })

//   // Update node class names
//   group.updateClasses()
//   group.attributes.filter(attribute => attribute.is.active || attribute.is.selected).forEach(attribute => {
//     attribute.syncWithDOM(group.nodes.attributes)
//   })
//   parentNode.appendChild(group.nodes.container)
// }

MK.events.on('attribute:groups:updateDOM', (event = {}) => {
  console.log(event)
  try {
    AttributeGroup.container = AttributeGroup.container || document.getElementById(config.selectors.id.groups)
    console.log('AttributeGroup.container', AttributeGroup.container)
    // let parentNode = AttributeGroup.container || document.getElementById(config.selectors.id.groups)
    // Assign parentNode dynamically based on active resolution (desktop or mobile)
    console.log('DEBUG (attribute:groups:updateDOM) Adding attribute groups to DOM.')
    if (AttributeGroup.container) {
      // If no group has been selected, highlight the first active group.
      let group = (AttributeGroup.groups.find(group => group.is.active && group.is.highlighted) || AttributeGroup.groups.find(group => group.is.active))
      group && !group.is.highlighted && MK.events.emit('attribute:group:toggle', {
        target: group,
        property: 'highlighted',
        value: true
      })

      // Hide group container prior to DOM manipulation.
      !classList.has(AttributeGroup.container, 'hide') && classList.add(AttributeGroup.container, 'hide')

      // AttributeGroup.groups.forEach(group => group.nodes.container.remove())
      // Clear existing DOM nodes.
      while (AttributeGroup.container.firstChild) {
        // console.log('AttributeGroup.container', AttributeGroup.container)
        AttributeGroup.container.removeChild(AttributeGroup.container.firstChild)
      }

      // console.log('AttributeGroup.container', AttributeGroup.container)

      AttributeGroup.groups.filter(group => group.is.active).forEach(group => {
        group.isActive()
        group.syncWithDOM()
        // AttributeGroup.container = AttributeGroup.container || document.getElementById(config.selectors.id.groups)
        // console.log('AttributeGroup.container', AttributeGroup.container)
        // AttributeGroup.container.appendChild(group.nodes.container)
      })

      // classList.remove(refinementFilters, 'hide')
      classList.remove(AttributeGroup.container, 'hide')
    }

    // Update selected attribute count.
    let element = document.getElementById(config.selectors.id.activeAttributeCountMobile)
    let selectedAttributes = document.getElementsByClassName('attr selected')

    // Assign data-count element based on the number of selected (currently active) attributes
    element && element.setAttribute && element.setAttribute('data-count', `${selectedAttributes.length}`)

    // MK.events.emit('attribute:groups:update:selectedAttributeCount', {
    //   initiator: 'attribute:groups:updateDOM'
    // })

  } catch (error) {
    console.log('!!! ERROR (attribute:groups:updateDOM) Error adding attribute groups to DOM.')
    console.log(error)
    MK.captureException(error)
  }
})
